import React from 'react';
import type { FooterMoreProps } from './types';
import { isNil, isNotNil, useNavigator } from '../../../../utils';
import { Flex, PrimaryButton } from '@banhala/ui-kit';
import { useOpenDeeplink } from '../../../../hooks';
import { useLogAnalyticsEvent } from '../../../../hooks/useLogAnalyticsEvent';

export const FooterMore: React.FC<FooterMoreProps> = ({ footer, screen }) => {
  const { openDeeplink } = useOpenDeeplink();
  const { navigator } = useNavigator();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  if (isNil(footer)) return null;

  const handleClickViewAllButton = () => {
    const { deeplink } = footer.item;
    if (deeplink === null) {
      return;
    }

    logAnalyticsEvent({
      name: 'CLICK_MORE',
      analytics: {
        ...(isNotNil(screen) && { SCREEN: screen }),
        ...footer.logging.analytics,
      },
      ably_only_log: footer.logging.ably_only_log,
    });

    if (navigator.moveToGoodsList(deeplink)) return;

    openDeeplink(deeplink);
  };

  return (
    <Flex padding={{ horizontal: 16 }} margin={{ top: footer.item.margin_top }}>
      <PrimaryButton
        color="gray"
        size="large"
        variant={'fill'}
        outline
        onPress={handleClickViewAllButton}
      >
        {footer.item.title}
      </PrimaryButton>
    </Flex>
  );
};
